export default __webpack_public_path__ + "static/media/article-2.2775bf49.png";